import React, { useState, useEffect } from "react";
import queryString from "query-string"; //this will help us in retrieving data from the url
import io from "socket.io-client";
import "./chat.css";
import InfoBar from "./InfoBar/infobar";
import Input from "./Input/input";
import Messages from "./Messages/messages";

let socket;
class Chat extends React.Component{
	infoBarRef=React.createRef()
	inputRef=React.createRef()

	state={
		name :"",
		room : "",
		message : "",
		messages : [],
		userNameOnline : [],
		messageheight:{
			infobar:"",
			input:""
		}
	}

componentDidMount(){
	const ENDPOINT = "https://mosboychatapp.herokuapp.com"
		const { name, room } = queryString.parse(this.props.location.search);
		const getPreviousMessages = localStorage.getItem(`${name}${room}`)
		if(getPreviousMessages) this.setState({messages:JSON.parse(getPreviousMessages)})//getting all the message that was saved to localStorage

		socket = io(ENDPOINT); //getting the server add for socket io connection
		this.setState({name});
		this.setState({room});
		socket.emit("join", { name, room }, (
			gettingCallback //this 3rd parameter will receive the message that was returned from the callback of the server side
		) => {
			if (gettingCallback) {
				
				//alert(gettingCallback)
			}

		});

			
		  socket.on("message", (message) => {
		//alert(`${message.text},please speak well to him.`)
		const messages = [...this.state.messages,message]
		this.setState({messages}) //this will add any new messages sent by admin or any member of the chat
		localStorage.setItem(`${name}${room}`,JSON.stringify(messages))
	});
		   
		   socket.on("roomData", (userINFO) => {
		const userInfoName = userINFO.users.map((user) => user.name);
		
		this.setState({userNameOnline:[...userInfoName]});
	});
}

updateMessage = (message) =>{
	this.setState({message})
}
sendMessage = (e) => {
	const {name, room, message} = this.state
	e.preventDefault();
	let date = new Date();
	const DayofWeek= ["sun","mon","tue","wed","thur","fri","sat"]
	const time = `${DayofWeek[date.getDay()]}, ${date.getHours()}:${date.getMinutes()}`;
	if (message) {
		socket.emit("sendMessage",{ message, name, room, time },(callbackError) => {
				this.setState({message:""});
				if (callbackError) {
					alert(callbackError);
				}});
	}
};

 componentWillUnmount(){
		socket.emit("disconnect"); //emit a disconnect event to the server
		socket.off(); //cut off the socket from other connected socket	
}

render(){
	const {name,room,userNameOnline,messages,message} = this.state
	const {sendMessage} = this;
	return (
		   <main>
			<div className="chat_outerContainer">
				<div className="chat_container">
					<InfoBar passref={this.infoBarRef}
						name={name}
						room={room}
						userNameOnline={userNameOnline}
						messages={messages}
					/>
					<Messages messages={messages} name={name} room={room}/>
					<Input passref={this.inputRef}
						message={message}
						updateMessage={this.updateMessage}
						sendMessage={sendMessage}
					/>
				</div>
			</div>
		</main>
);
}
}
	
export default Chat;
